export function ColorIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M11.27 4.033a4.854 4.854 0 011.95.184c.3.087.587.368.746.942a3.06 3.06 0 01-.07 1.79c-.437 1.176-.577 2.637.227 4.105a4.396 4.396 0 002.649 2.15c.628.191 1.34.617 1.82 1.134.493.532.572.952.479 1.239-.134.411-.312.762-.752 1.329A8 8 0 1111.27 4.033zm2.505-1.737a6.844 6.844 0 00-2.688-.254 10 10 0 108.812 16.09c.55-.709.854-1.262 1.073-1.937.418-1.282-.194-2.441-.914-3.217a6.365 6.365 0 00-2.707-1.687 2.399 2.399 0 01-1.474-1.197c-.451-.824-.402-1.653-.107-2.449a5.056 5.056 0 00.123-3.02c-.27-.975-.921-1.983-2.118-2.329zM9 9a1 1 0 100-2 1 1 0 000 2zm-1 6a2 2 0 100-4 2 2 0 000 4zm7 1a2 2 0 11-4 0 2 2 0 014 0z"
      ></path>
    </svg>
  );
}
